import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import CardContent from '@material-ui/core/CardContent';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';

export const OrderLineCardSkeleton = () => (
  <Grid item xs={12}>
    <Card>
      <Box display="flex" alignItems="center" paddingLeft={1}>
        <Skeleton variant="rect" width={24} height={24} style={{ marginLeft: 8 }} />
        <Box flex="1">
          <CardContent>
            <Skeleton variant="text" />
          </CardContent>
        </Box>
      </Box>
    </Card>
  </Grid>
);

const OrderLineCard = ({ orderLine, SelectionComponent }) => (
  <Grid item xs={12}>
    <Card>
      <Box display="flex" alignItems="center" flexWrap="nowrap" paddingLeft={1}>
        <SelectionComponent />
        <Box flex="1" ml={-1}>
          <CardContent style={{ paddingBottom: 16 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <div>
                <Typography variant="subtitle1">{orderLine?.sku}</Typography>
                <Typography variant="body2">{orderLine?.description}</Typography>
              </div>
              <Typography variant="h6" style={{ marginLeft: 12 }}>
                {orderLine?.quantity}
              </Typography>
            </Box>
          </CardContent>
        </Box>
      </Box>
    </Card>
  </Grid>
);

OrderLineCard.propTypes = {
  SelectionComponent: PropTypes.element,
  orderLine: PropTypes.object,
};

OrderLineCard.defaultProps = {
  SelectionComponent: undefined,
  orderLine: {},
};

export default OrderLineCard;
